module.exports = __webpack_public_path__ + "assets/a7d4084004720aee6724454bec520bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/1.png
// module id = 339
// module chunks = 1